export const messages = {
  en: {
    couponPropertyUserManage: {
      page: {
        title: 'Owner Coupons',
        subtitle: 'View the coupons held by owners and their usage status',
        loadFailed: 'Failed to load coupon data',
        empty: 'No owner coupons found'
      },
      search: {
        title: 'Search Conditions',
        couponId: 'Coupon ID',
        couponName: 'Coupon Name',
        validityDay: 'Validity Day',
        userName: 'User Name',
        tel: 'Phone Number',
        toType: 'Usage',
        selectToType: 'Select Usage',
        shopping: 'Shopping',
        payment: 'Payment',
        repair: 'Repair Coupon',
        parking: 'Parking Coupon',
        state: 'Status',
        selectState: 'Select Status',
        unused: 'Unused',
        used: 'Used'
      },
      list: {
        title: 'Owner Coupons'
      },
      table: {
        couponId: 'ID',
        couponName: 'Coupon Name',
        value: 'Face Value',
        validityDay: 'Validity',
        userName: 'User Name',
        tel: 'Phone',
        toType: 'Usage',
        quantity: 'Quantity',
        sheet: 'Sheet',
        state: 'Status',
        startTime: 'Effective Time',
        unused: 'Unused',
        used: 'Used'
      },
      fetchError: 'Failed to fetch coupon data'
    }
  },
  zh: {
    couponPropertyUserManage: {
      page: {
        title: '业主优惠券',
        subtitle: '查看业主持有的优惠券及其使用状态',
        loadFailed: '获取优惠券数据失败',
        empty: '暂无业主优惠券'
      },
      search: {
        title: '查询条件',
        couponId: '优惠券编号',
        couponName: '优惠券名称',
        validityDay: '有效期',
        userName: '用户名称',
        tel: '手机号',
        toType: '用途',
        selectToType: '选择用途',
        shopping: '购物',
        payment: '缴费',
        repair: '维修劵',
        parking: '停车劵',
        state: '状态',
        selectState: '请选择状态',
        unused: '未使用',
        used: '已使用'
      },
      list: {
        title: '业主优惠券'
      },
      table: {
        couponId: '编号',
        couponName: '优惠券名称',
        value: '面值',
        validityDay: '有效期',
        userName: '用户名称',
        tel: '手机号',
        toType: '用途',
        quantity: '数量',
        sheet: '张',
        state: '状态',
        startTime: '生效时间',
        unused: '未使用',
        used: '已使用'
      },
      fetchError: '获取优惠券数据失败'
    }
  }
}